export default __webpack_public_path__ + "static/media/7.2.06445465.webm";